import new_file from "frontend/files/make/new_file"
import create_blob from "workflow/utils/create_blob"

export default ({ id, bytes, name, type }) =>
  new_file({ id, name, type, url: create_blob(bytes, type) })
